module.exports = __webpack_public_path__ + "static/media/STAF_bokmål_sekundærlogo_pos(svart).752f4fca.png";